import React from "react";
import { Box, Typography, Paper } from "@material-ui/core";

function LetterToParentsTab({ }) {
    return (
        <Box display="flex" justifyContent="center" width="100%" mt={2}>
            <Paper
                elevation={0}
                style={{
                    maxWidth: 1300,
                    minHeight: 510,
                    width: "100%",
                    margin: "0 auto",
                    borderRadius: 12,
                    background: "#fff",
                    padding: "40px 36px 32px 36px",
                }}
            >
                <Typography variant="subtitle1" style={{ color: "#ff5758", fontWeight: 700, marginBottom: 18 }}>
                    Dear Parent
                </Typography>
                <Typography style={{ marginBottom: 12 }}>
                    This AI Readiness Report provides valuable insights into your child's digital life, serving as a starting point for constructive conversations about digital skills, opportunities, and potential risks. Guiding your child's digital experiences can greatly enhance their mental health, digital wellbeing, personal strengths, and overall preparedness for a future increasingly shaped by artificial intelligence (AI).
                </Typography>
                <Typography style={{ marginBottom: 18 }}>
                    Encouraging positive and effective digital habits can significantly improve your child's digital competencies, preparing them confidently for the AI-driven world. However, being aware of digital risks is equally important.
                </Typography>
                <Typography variant="subtitle1" style={{ fontWeight: 700, marginBottom: 10 }}>
                    Recommendations:
                </Typography>
                <Box component="ul" pl={3} mb={2} style={{ marginTop: 0 }}>
                    <li style={{ marginBottom: 6 }}>
                        <span style={{ color: "#ff5758", fontWeight: 700 }}>
                            Take a proactive role:
                        </span>{" "}
                        Our generation is pioneering digital parenting—actively engaging with your child helps foster positive digital skills.
                    </li>
                    <li style={{ marginBottom: 6 }}>
                        <span style={{ color: "#ff5758", fontWeight: 700 }}>
                            Encourage open dialogue:
                        </span>{" "}
                        Being approachable and supportive helps your child comfortably discuss their online experiences, both positive and challenging.
                    </li>
                    <li style={{ marginBottom: 6 }}>
                        <span style={{ color: "#ff5758", fontWeight: 700 }}>
                            Set clear, respectful boundaries:
                        </span>{" "}
                        Establishing appropriate device usage guidelines helps your child develop healthy digital habits.
                    </li>
                    <li style={{ marginBottom: 6 }}>
                        <span style={{ color: "#ff5758", fontWeight: 700 }}>
                            Teach practical coping skills:
                        </span>{" "}
                        Prepare your child to manage online interactions responsibly and safely, enhancing their resilience to potential cyber risks.
                    </li>
                </Box>
                <Typography style={{ marginBottom: 24 }}>
                    Additionally, we encourage you to explore the Digital Parenting Index and other relevant assessments within the AI Readiness Assessment Package. These resources will further equip you to effectively guide and support your child’s digital growth.
                </Typography>

                <Typography
                    variant="body2"
                    style={{
                        color: "#444",
                        fontSize: 13,
                        fontStyle: "italic",
                        marginTop: 20,
                        borderTop: "1px solid #f2f2f2",
                        paddingTop: 16,
                    }}
                >
                    <b>Disclaimer</b>
                    <br />
                    <span style={{ fontStyle: "normal", fontWeight: 400 }}>
                        <i>
                            Limitations of Content: This report provides a snapshot of your child’s digital intelligence and safety based on responses provided in the AI Readiness Assessment. Since it relies on self-reported information, its accuracy depends entirely on the honesty and accuracy of your child’s responses. This report does not constitute legal or medical advice.
                            <br />
                            <br />
                            Confidentiality: This report may contain sensitive personal information and is intended exclusively for the parents or legal guardians of the child participant, as well as educational professionals who have explicit parental permission to access this information.
                        </i>
                    </span>
                </Typography>
            </Paper>
        </Box>
    );
}

export default LetterToParentsTab;